interface EmailData {
    name: string;
    email: string;
    question: string;
}

export const sendEmail = async (data: EmailData): Promise<void> => {
    console.log("Sending email:", data);
    try {
        // Create an AbortController to handle timeout
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
        
        const response = await fetch('https://mail.galacticpathfinder.com/email-sender/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            signal: controller.signal
        });

        // Clear the timeout since the request completed
        clearTimeout(timeoutId);
        
        console.log("Response status:", response.status);
        console.log("Response headers:", response.headers);
        
        // Try to get response text regardless of content type
        let responseText;
        try {
            responseText = await response.text();
            console.log("Response text:", responseText);
        } catch (e) {
            console.error("Failed to get response text:", e);
        }
        
        // Try to parse as JSON if possible
        let responseData;
        if (responseText) {
            try {
                responseData = JSON.parse(responseText);
                console.log("Response data:", responseData);
            } catch (e) {
                console.log("Response is not JSON");
            }
        }

        if (!response.ok) {
            throw new Error(`Failed to send email: ${response.status} ${response.statusText}${responseData?.error ? ` - ${responseData.error}` : ''}`);
        }

        return responseData;
    } catch (error) {
        console.error('Error sending email:', error);
        // Check if it's an abort error (timeout)
        if (error instanceof Error && error.name === 'AbortError') {
            throw new Error('Request timed out. The server might be down or unreachable.');
        }
        throw error;
    }
};